module.exports = __webpack_public_path__ + "static/python-2-86987392329a8be3a4b9a95234117bb1.svg";